import * as React from 'react';
import { Fab } from '@mui/material';
import { IDeleteAction } from './interfaces';
import DeleteIcon from '@mui/icons-material/Delete';

export const DeleteAction: React.FC<IDeleteAction> = ({
  disabled = false,
  onClick,
}): JSX.Element => {
  return (
    <Fab color="error" onClick={onClick} disabled={disabled}>
      <DeleteIcon />
    </Fab>
  );
};
